// You can write your custom Javascript here
if(document.getElementsByClassName('discover-btn').length > 0){
  document.getElementsByClassName('discover-btn')[0].addEventListener('mouseover', () => {
    let discoverMenu = document.getElementsByClassName('menu--discover')[0].getElementsByClassName('dropdown__menu')[0]
    discoverMenu.style.borderTop = "1px solid #c8c8c8"
    discoverMenu.style.maxHeight = "1000px"
    document.getElementsByTagName('body')[0].classList.add('no-scroll');
  })
  document.getElementsByClassName('discover-btn')[0].addEventListener('mouseout', () => {
    let discoverMenu = document.getElementsByClassName('menu--discover')[0].getElementsByClassName('dropdown__menu')[0]
    discoverMenu.style.removeProperty('border-top');
    discoverMenu.style.removeProperty('max-height');
    document.getElementsByTagName('body')[0].classList.remove('no-scroll');
  })
}

function hideMobileMenuBanner() {
  var banner = document.querySelector('.mobile-menu-banner');
  if (banner) banner.classList.add('hide');
}

function removeMobileMenuBanner() {
  var banner = document.querySelector('.mobile-menu-banner');
  if (banner) banner.classList.remove('hide');
}

// Hide promo banner when drilling into a primary item with a dropdown, or when using the mobile back row.
document.addEventListener('click', function (event) {
  if (event.target.closest('.menu__item--primary .dropdown-item') && !event.target.closest('.menu__item--primary .dropdown-item.active')) {
    hideMobileMenuBanner();
    return;
  }
  if (event.target.closest('.menu__item--primary .dropdown-item.active')) {
    removeMobileMenuBanner();
    return;
  }
});

// Anchor the mobile drawer under the header bar 
// whenever the header changes so an opening search bar pushes the drawer down.
(() => {
  const header = document.getElementById('headerSection');
  if (!header) return;

  const syncDrawerTop = () => {
    const top = Math.round(header.getBoundingClientRect().bottom);
    if (top <= 0) return;
    document.documentElement.style.setProperty('--mobile-drawer-top', `${top}px`);
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('.mobile__triggers .hamburger')) syncDrawerTop();
  }, true);

  new MutationObserver(() => requestAnimationFrame(syncDrawerTop))
    .observe(header, { attributes: true, attributeFilter: ['class', 'style', 'hidden'], subtree: true });
})();

// Mobile accordion for mega menu sections
document.querySelectorAll('.mega__menu .submenu__links .menu__item--secondary:first-child')
  .forEach((section) => section.classList.add('is-open'));

document.addEventListener('click', (event) => {
  if (window.innerWidth > 1240) return;
  const heading = event.target.closest('.mega__menu .submenu__heading');
  const section = heading && heading.closest('.menu__item--secondary');
  if (!section || !section.querySelector('.sub-submenu')) return;
  event.preventDefault();
  section.classList.toggle('is-open');
});

document.querySelectorAll('.announcement-bar__slider').forEach(function (slider) {
  function toVertical(retriesLeft) {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) {
      if (retriesLeft > 0) setTimeout(function () { toVertical(retriesLeft - 1); }, 100);
      return;
    }
    var $slider = jQuery(slider);

    var dots = slider.getAttribute('data-dots') === 'true';
    var loop = slider.hasAttribute('data-loop');
    var speed = parseInt(slider.getAttribute('data-speed'), 10) || 3000;

    $slider.slick('unslick');
    $slider.slick({
      vertical: true,
      verticalSwiping: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      dots: dots,
      arrows: false,
      autoplay: loop,
      autoplaySpeed: speed
    });
  }

  if (slider.classList.contains('slick-initialized')) {
    toVertical(20);
    return;
  }

  var timeoutId = setTimeout(function () {
    observer.disconnect();
  }, 10000);

  var observer = new MutationObserver(function () {
    if (slider.classList.contains('slick-initialized')) {
      clearTimeout(timeoutId);
      observer.disconnect();
      toVertical(20);
    }
  });
  observer.observe(slider, { attributes: true, attributeFilter: ['class'] });
});

// Fix AudioEye cart issue: its scanner marks the offscreen .sidecart `inert`
// and never clears it, so open-drawer clicks fall through to the close
// overlay. Cleared only while open so other modals' focus traps are left alone.
document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-shipping-bar]');
  if (!bar) return;

  const fill = bar.querySelector('[data-shipping-bar-fill]');
  const message = bar.querySelector('[data-shipping-bar-message]');
  const { threshold, msgEmpty, msgProgress, msgSuccess } = bar.dataset;

  const update = (cart) => {
    const goal = threshold * (Shopify.currency.rate || 1);
    const total = cart.total_price;
    const remaining = Math.max(goal - total, 0);
    const money = (cents) => new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active, minimumFractionDigits: 0 }).format(cents / 100);

    fill.style.width = `${Math.min(total / goal, 1) * 100}%`;
    bar.classList.toggle('is-empty', !total);
    bar.classList.toggle('is-complete', !remaining);
    message.textContent = !total ? msgEmpty.replace('{{ amount }}', money(goal))
      : remaining ? msgProgress.replace('{{ amount }}', money(remaining))
      : msgSuccess;
  };

  jQuery(document).on('cart.ready cart.requestComplete', (_, cart) => update(cart));
});

// Fix AudioEye cart issue
(function () {
  var drawer = document.querySelector('.sidecart');
  if (!drawer) return;

  function clearInert() {
    if (document.body.classList.contains('ajax-cart-open') && drawer.hasAttribute('inert')) {
      drawer.removeAttribute('inert');
    }
  }

  clearInert();
  new MutationObserver(clearInert).observe(drawer, { attributes: true, attributeFilter: ['inert'] });
  new MutationObserver(clearInert).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();

(() => {
  const DEFAULT_THRESHOLD = 5;
  const VARIANT_INPUTS = '.product__form input.radio, .product__form [data-product-select]';

  const isLowStock = (option, threshold) => {
    if (!option || option.disabled) return false;
    const qty = Number.parseInt(option.dataset.variantQty, 10);
    return qty > 0 && qty <= threshold;
  };

  const updateLowStock = (form) => {
    const message = form.querySelector('[data-low-stock]');
    const select = form.querySelector('[data-product-select]');
    if (!message || !select) return;

    const option = select.selectedOptions[0];
    const threshold = Number.parseInt(message.dataset.lowStockThreshold, 10) || DEFAULT_THRESHOLD;
    const show = isLowStock(option, threshold);

    if (show) {
      const count = message.querySelector('[data-low-stock-count]');
      if (count) count.textContent = option.dataset.variantQty;
    }
    message.hidden = !show;
  };

  document.addEventListener('change', ({ target }) => {
    if (!target.matches(VARIANT_INPUTS)) return;
    const form = target.closest('form');
    if (form) updateLowStock(form);
  });
})();

// Store money format drops decimals, discount amounts may be to the cent
// Done here because custom.js runs after rivets-cart loads and before main.bundle.js binds
if (window.rivets) {
  rivets.formatters.money_cents = (cents) =>
    CartJS.settings.moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (cents / 100).toFixed(2));

  // Sum of product-level discounts across the cart
  rivets.formatters.line_discount_total = (items) =>
    (items || []).reduce((total, item) =>
      total + (item.line_level_discount_allocations || []).reduce((sum, d) => sum + d.amount, 0), 0);
}

